module.exports = __webpack_public_path__ + "img/icon-leads.199e1846.svg";